import { departments } from "./departments/departments";
import { negotiation } from "./negotiation/negotiation";
import { permissions } from "./permissions/permissions";
import { roles } from "./roles/roles";
import { subscriptions } from "./subscriptions/subscriptions";
import { titles } from "./titles/titles";
import { tenantConfig } from "./tenantConfig/tenantConfig";
import { trades } from "./trades/trades";
import { users } from "./users/users";
import { recordPermissions } from "./recordPermissions/recordPermissions";
import { roleRecordPermissions } from "./roleRecordPermissions/roleRecordPermissions";
import { userProfile } from "./userProfile/userProfile";

export const subscriptionService = {
  subscriptions,
  userProfile,
  users,
  departments,
  roles,
  permissions,
  titles,
  tenantConfig,
  trades,
  recordPermissions,
  negotiation,
  roleRecordPermissions,
};
